import { Plan } from '@workspaces/types'

export function serializeLegend(legend: Plan.Legend): Plan.Legend {
  return {
    boundariesVisibility: legend.boundariesVisibility ?? true,
    assetsIdsLayerVisibility: legend.assetsIdsLayerVisibility ?? false,
    colorizeAssets: legend.colorizeAssets ?? true,
    productClass: legend.productClass ?? 'l2product_id',
    facingOrientationsIcons: legend.facingOrientationsIcons ?? false,
    angleNorthMap: legend.angleNorthMap ?? false,
    hiddenProductsId: legend.hiddenProductsId ?? [],
  }
}
